<template>  
  <div>
    <q-card v-if="openWork">
      <q-card-title>
        <img v-if="false" width="260px" src="@/assets/Insafety.png">
        <p>{{$t('global.EndWork')}}</p>
      </q-card-title>
      <q-card-main>
        <p class="text-weight-bold">{{openWork.GeoRegionDescription}}, {{ openWork.WorkDescription}}</p>
        <p>{{$t('global.WorkStart')}}: {{ dateFormat(openWork.Starting) }}</p>
        <q-input class="comment" v-model="openWork.Comment" rows="2" :float-label="$t('global.Comment')" type="textarea" />
        <q-datetime @input="stopTimer" v-model="ending" type="datetime" :float-label="$t('global.WorkEnd')" format="D.MMM.YYYY HH:mm"/>
        <p class="timer text-weight-bold">{{ timeElapsed }}</p>
        <q-card-separator/>
        <p></p>
        <q-btn class="dialog" color="positive" @click="WorkEnd('Stop')" >{{$t('global.Stop')}}</q-btn>
        &nbsp;
        <q-btn class="dialog" color="positive" v-if="openWork.IsAssignedWork == true" @click="WorkEnd('End')" >{{$t('global.Finish')}}</q-btn>
      </q-card-main>
    </q-card>  
  </div>
</template>

<script>
import { date } from 'quasar'
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SideDialogCloseWork',
  data () {
    return {
      form: {
        SessionId: null,
        action: 'getOpenWork',
      },
      openWork: null,
      ending: new Date(),
    }
  },
  methods: {
    getGps (){
      var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
      if(navigator.geolocation){
        navigator.geolocation.getCurrentPosition(position => {
          this.positions.push(position.coords);
          console.log(position)
        }, error, options)
      }
       else {
         alert("Geolocation is not supported by this browser.")
      }
    },
    dateFormat(val) {
      return date.formatDate(val, this.$store.state.session.DateTimeFormat)
    },
    stopTimer (){
      this.setTimer(false) 
    },

      WorkEnd (type) {
      //send end work to server
      this.form.IdWork = this.openWork.IdWork
      this.form.SessionId = this.$store.state.session.SessionId

      this.form.action = 'WorkStop'

      this.form.Ending = this.ending

      if(type == 'End')
        this.form.done = true
      else
        this.form.done = false

    
      this.form.Comment = this.openWork.Comment

      
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          console.log(response.data)
          console.log(response)
          if(response.status == 200){ 
            this.$store.state.session.NeedsClosing = false
            this.$q.notify({ message: this.$t('global.WorkEnded'), type: 'positive' })
            eventBus.$emit('workChange', null)
            eventBus.$emit('closeDialog', null)
            this.$router.push({name: 'Journal'})
          }
          else{
              this.$q.notify('Error')
          }
      })
      .catch(e => {
          this.submitting = false
          if(e.response.status == 403){
              this.$q.notify('Error')

          }
          console.log(e)
      }) 

    },
    setTimer(on) {
      if (!on) {
        clearInterval(this.interval);
      } else {
        this.interval = setInterval(this.incrementTime, 1000);
      }    
    },
    incrementTime() {
      this.ending = new Date()
    },
  },
  
  created () {
    //alert('mounted, load open work')
    this.form.SessionId = this.$store.state.session.SessionId
    this.form.action = "getOpenWork"

    axios.post(this.$apiUrl,
    qs.stringify(this.form),
    {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then(response => {
        console.log(response)
        if(response.status == 200){ 
              this.openWork = response.data  
              this.setTimer(true)        
        }
        else{
            this.$q.notify('ERROR')
        }
    })
    .catch(e => {        
      this.$q.notify('ERROR')      
      console.log(e);
    })



  },

  computed: {
    timeElapsed: function () {
      var seconds = date.getDateDiff(this.ending, this.openWork.Starting, 'seconds')
      return Math.floor(this.moment.duration(seconds,'seconds').asHours()) + ':' + this.moment.duration(seconds,'seconds').minutes() + ':' + this.moment.duration(seconds,'seconds').seconds(); 
    },
  },
}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}

</script>
<style scoped>
.timer{
  text-align: center;
  padding-top: 10px;
}
</style>
